module.exports = __webpack_public_path__ + "img/art-47.e58ae149.png";